
const  saveBroker = async ( data ) => {
    try {
        const response = await axios.post( "/brokers/store", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
}

const getBroker = async (id) => {
    try {
        const response = await axios.get(`/brokersResources/${id}`);
        return {data : response.data};
    } catch (error) {
        console.log("Error al obtener los datos", error);
        return {data : null, message: error.response.data.message};
    }
};

const updateBroker = async (data) => {
    try {
        const response = await axios.put(`/brokersResources/${data.id}`, data);
        return {updated : true, message: response.data.message};
    } catch (error) {
        console.log("Error al actualizar los datos", error);
        return {updated : false, message: error.response.data.message};
    }
};

const deleteBroker = async (id) => {
    try {
        const response = await axios.delete(`/brokersResources/${id}`)
        return {deleted : true, message: response.data.message};
    } catch (error) {
        console.log("Error al eliminar los datos", error);
        return {deleted : false, message: error.response.data.message};
    }
};



export { saveBroker, getBroker, updateBroker, deleteBroker };